import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from "axios";

interface UseToggleContactDocumentProps {
  contactId?: string
  privateCompanyLeadId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: () => void
}

const useToggleContactDocument = ({ contactId, privateCompanyLeadId, onSuccess, onError }: UseToggleContactDocumentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['toggleContactDocument'],
    mutationFn: ({ value, type, documentId }: { value: boolean, type: string, documentId?: string }) => {
      const private_company_lead = {
        contacts_attributes: [
          {
            id: contactId,
            documents_attributes: [
              value
                ? { type }
                : { id: documentId, _destroy: true }
            ]
          }
        ]
      }

      return privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}

export default useToggleContactDocument
